import GeaoLayout from "../shared/Layout/GeaoLayout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { classes } from "../../../../util/style-utils";
import { getOtpFieldsFromInterview } from "../../../../api/search";
import { useNavigate } from "react-router-dom";
import { GeaoPaths } from "../../constants/GeaoPaths";
import { EMAIL_WITH_TLD_REGEX } from "../../../../constants/ValidationConstants";

const validationSchema = yup.object().shape({
    businessEmailAddress: yup.string()
        .required("Please enter your business email address.")
        .email("Please enter a valid email address.")
        .matches(EMAIL_WITH_TLD_REGEX, "Please enter a valid email address."),
});

export default function ApplicationStatus() {

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const navigate = useNavigate();
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [showError, setShowError] = useState(false);

    function onSubmit(values) {
        setButtonsDisabled(true);

        getOtpFieldsFromInterview(
            { businessEmailAddress: values.businessEmailAddress },
            (response) => {
                navigate(GeaoPaths.RecallSendCode, { state: response });
            },
            (error) => {
                if (error.status === 404) {
                    setShowError(true);
                } else {
                    navigate(GeaoPaths.TechnicalDifficulties);
                }
            },
            () => setButtonsDisabled(false)
        );
    }

    return (
        <GeaoLayout header="View Application Status">
            <form className="form geao-form" onSubmit={handleSubmit(onSubmit)} style={{ width: "750px" }} >
                <p className="text">
                    Enter your agency business email to access your application.
                </p>
                <div className="flex-row">
                    <div className={classes("form-field", errors.businessEmailAddress && "form-field--error")}>
                        <label htmlFor="businessEmailAddress" className="text">
                            Business Email Address
                        </label>
                        <input
                            type="text"
                            {...register("businessEmailAddress")}
                        />
                        {errors.businessEmailAddress && (
                            <span className="form-message">
                                {errors.businessEmailAddress.message}
                            </span>
                        )}
                    </div>
                </div>

                {showError &&
                    <div className="flex-row">
                        <div className="alert">
                            <div className="alert--high-importance">
                                <span className="icon-alert" />
                                <ul className="alert-list">
                                    <li className="alert-content">
                                        <div className="h4">Email Not Found</div>
                                        <p>
                                            We couldn’t find the email address you entered. Please try again or&nbsp;
                                            <a href={GeaoPaths.CreateYourProfile} className="link">
                                                Create a New Profile.
                                            </a>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }

                <div className="flex-row">
                    <div className="col-sm-12">
                        <button
                            type="submit"
                            className="btn btn--primary btn--full-mobile btn--pull-right"
                            disabled={buttonsDisabled}
                        >
                            <span>Continue</span>
                        </button>
                    </div>
                </div>
            </form>
        </GeaoLayout>
    );
}
